<template>
  <div class="info_card">
    <div class="dates" v-if="(!isExpanded && !card.canCollapse) || isExpanded">
      <div class="date" v-for="(date, index) in card.dates" :key="index">
        <p>{{ date }}</p>
        <h6 v-if="card.dateNames.length > 0">{{ card.dateNames[index] }}</h6>
      </div>
    </div>

    <div class="info" v-if="isExpanded">
      <div class="infoItem" v-for="(infoItem, index) in card.info" :key="index">
        <p>{{ infoItem }}</p>
      </div>
    </div>

    <div class="card_heading" :class="{ expanded: isExpanded }">
      <div class="titles">
        <h4>{{ card.subtitle }}</h4>
        <h1>{{ card.title }}</h1>
      </div>

      <div class="collapse" v-if="card.canCollapse">
        <i
          class="fas"
          :class="isExpanded ? 'fa-compress-alt' : 'fa-expand-alt'"
          @click="toggleExpand"
        ></i>
      </div>
    </div>
  </div>
</template>

<script src="./InfoCard.js"></script>
<style src="./InfoCard.scss" lang="scss" scoped></style>